'use strict';

module.exports = function ($stateProvider) {
    $stateProvider
    // FILES
        // BY MIME
        .state('pages.main.files_by_mime', {
            url: '/files_by_mime',
            template: require('../views/files/files_by_mime.html'),
            controller: 'filesByMimeController',
            controllerAs: 'page',
            data: {
                title: 'Files By MIME',
                daterange: true
            }
        })
            // BY MIME TYPE
            .state('pages.main.files_by_mime_type', {
                url: '/files_by_mime_type',
                template: require('../views/files/files_by_mime_type.html'),
                controller: 'filesByMimeTypeController',
                controllerAs: 'page',
                data: {
                    title: 'Files By MIME Type',
                    daterange: true
                }
            })
                // BY MIME TYPE
                .state('pages.main.files_by_mime_type_filename', {
                    url: '/files_by_mime_type_filename',
                    template: require('../views/files/files_by_mime_type_filename.html'),
                    controller: 'filesByFileNameController',
                    controllerAs: 'page',
                    data: {
                        title: 'Files By File Name',
                        daterange: true
                    }
                })
}




/** WEBPACK FOOTER **
 ** ./src/pages/routes/files.js
 **/